<template>
  <div>
    <!-- コンポーネントのHTMLをここに記述 -->
    <div v-if="displayData.length > 0" class="selected-subsidy-list">
      <div class="selected-subsidy-list-item">
        <span class="title font-bold label-l">補助申請額合計</span>
        <span class="price">{{ totalprice  | formatCurrency }}</span>
      </div>
      <div v-for="(item,j) in displayData" :key="j" class="selected-subsidy-list-item">
        <span class="title">{{ item.subsidyName }}</span>
        <span class="price">{{ item.price  | formatCurrency }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'SelectedSubsidyList', // コンポーネント名
  props: {
    selectedSubsidyList: {
      type: Array,
      required: true,
    },
  },
  created() {
    // コンポーネントが作成されたときに実行したい処理
    // this.selectedSubsidyList.forEach((item) => {
    //   this.dev(item);
    // });
  },
  data() {
    return {
      // データプロパティ
      displayData: [],
      totalprice: 0,
    };
  },
  watch: {
    selectedSubsidyList(newValue, oldValue) {
      console.log('selectedSubsidyList changed from', oldValue, 'to', newValue);
      this.setDisplayData(newValue);
    }
  },
  methods: {
    dev: function(msg) {
      // console.log(msg);
    },
    dump: function(...args) {
      // console.log(...args);
    },
    calcPrice: function(priceList) {
      let price = 0;
      for (let i = 0; i < priceList.length; i++) {
        const item = priceList[i];
        price += item.price;
      }
      return price;
    },
    // メソッド
    setDisplayData: function(newData) {
      this.totalprice = 0;
      this.displayData = [];
      this.dump("newData", newData);
      const couponTotals = {}
      // 部屋分ループ
      for (let i = 0; i < newData.length; i++) {
        const item = newData[i];
        // クーポン分ループ
        for (let j = 0; j < item.subsidyList.length; j++) {
          const coupon = item.subsidyList[j];
          const price = this.calcPrice(coupon.priceList);
          const couponName = coupon.dispSubsidyNm;
          if(!couponTotals[couponName]){
            couponTotals[couponName] = 0
          }
          couponTotals[couponName] += price
          this.totalprice += price
        }
      }
      this.displayData = [];
      for (const [subsidyName, price] of Object.entries(couponTotals)) {
        this.displayData.push({ subsidyName, price });
      }
      this.dump("displayData", this.displayData);
    }
  },
  computed: {
    // 算出プロパティ
  },
  // その他のオプション...
};
</script>

<style scoped>
/* このコンポーネントに限定されたスタイル */
.selected-subsidy-list {
  margin-top: 20px; /* 上の余白 */
  text-align: right;
}
@media (min-width: 769px) {
  /* タブレットやデスクトップで適用されるスタイル */
  .selected-subsidy-list {
    width: 40%;
    margin-left: auto; /* 右寄せ */
  }
}
.selected-subsidy-list-title{
  text-align: left;
  margin-bottom: 10px; /* アイテム間の余白 */
}
.selected-subsidy-list-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px; /* アイテム間の余白 */
}

.title {
  text-align: left;
}

.price {
  text-align: right;
}
</style>
